"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var INVITE_USER_FORM = {
  title: 'Add a member',
  saveLabel: 'Add',
  fields: {
    email: {
      kind: 'email'
    }
  }
};
var OrgContentHubList = /*#__PURE__*/function () {
  OrgContentHubList.$inject = ["$rootScope", "orgService", "eventService", "userService", "modalService"];
  /* @ngInject */
  function OrgContentHubList($rootScope, orgService, eventService, userService, modalService) {
    _classCallCheck(this, OrgContentHubList);
    this.orgService = orgService;
    this.eventService = eventService;
    this.userService = userService;
    this.modalService = modalService;
    this.currentUser = userService.getCurrentUser();
    this.loading = true;
    this.setFlashMessage = function (message, level) {
      return $rootScope.setFlashMessage(message, level);
    };
    this.memberInEvents = this.currentUser.roles.filter(function (_ref) {
      var type = _ref.type,
        role = _ref.role,
        event_id = _ref.event_id;
      return type === 'event_permission' && role !== 'revoked' && event_id;
    }).map(function (role) {
      return role.event_id;
    });
  }
  return _createClass(OrgContentHubList, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _this = this;
      if (changes.organisation && this.organisation) {
        this.loading = true;
        this.canAddMembersToTeam = this.userService.hasPermission('access_modification_realms.add_event_team_member', {
          org_id: this.organisation._id
        });
        this.orgService.getAllOrgContentHubs(this.organisation.name).then(function (data) {
          return _this.contentHubs = data;
        }).catch(function (error) {
          console.error(error);
          _this.setFlashMessage('Failed to load content hubs', 'danger');
        }).finally(function () {
          return _this.loading = false;
        });
      }
    }
  }, {
    key: "joinContentHub",
    value: function joinContentHub(hub) {
      var _this2 = this;
      if (!this.canAddMembersToTeam) {
        return;
      }

      // needs to be called on cloud node
      this.eventService.addEventTeamMember(hub.id, this.currentUser.name, 'manager', hub.node).then(function () {
        _this2.setFlashMessage("You were added to ".concat(hub.name));
        _this2.memberInEvents.push(hub.id);
      }).catch(function (error) {
        console.error(error);
        _this2.setFlashMessage('Failed to join the content hub team', 'danger');
      });
    }
  }, {
    key: "inviteToContentHub",
    value: function inviteToContentHub(hub) {
      var _this3 = this;
      if (!this.canAddMembersToTeam) {
        return;
      }
      this.modalService.openModalWithForm(INVITE_USER_FORM).then(function (model) {
        var email = model.email;
        // needs to be called on cloud node
        _this3.eventService.addEventTeamMember(hub.id, email, 'manager', hub.node).then(function () {
          return _this3.setFlashMessage("".concat(email, " was added to ").concat(hub.name));
        }).catch(function (error) {
          console.error(error);
          _this3.setFlashMessage("Failed to add ".concat(email, " to team"), 'danger');
        });
      });
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.content-hub-list', ['backstage.services']).component('bsOrgContentHubList', {
  templateUrl: '/src/angular/components/orgs/view-org/org-content-hub-list/org-content-hub-list.html',
  bindings: {
    organisation: '<'
  },
  controller: OrgContentHubList
}).name;